import React from 'react';
import { LayoutIcon, InheritProps } from './Layout';

export function CarouselIcon(props: InheritProps) {
  return (
    <LayoutIcon
      {...props}
      childrenRender={(color: string) => (
        <svg
          width='100%'
          height='100%'
          viewBox='0 0 125 122'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          preserveAspectRatio='xMidYMid meet'
        >
          <rect
            x='3.5'
            y='1.5'
            width='119'
            height='119'
            rx='8.5'
            fill='#343434'
            stroke={color}
            strokeWidth='4'
          />
          <rect x='19' y='48' width='25' height='25' rx='5' fill='#D9D9D9' />
          <rect x='50' y='48' width='25' height='25' rx='5' fill='#D9D9D9' />
          <rect x='81' y='48' width='25' height='25' rx='5' fill='#D9D9D9' />
          <path d='M14 65L9 60L14 55V65Z' fill='#E7E0EC' />
          <path d='M110.047 55.0279L115.033 60.0418L110.02 65.0278L110.047 55.0279Z' fill='#E7E0EC' />
        </svg>
      )}
    />
  );
}
